export default function Calendar({ className = "" }) {
  return (
    <svg
      width="25"
      height="23"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g stroke="#101010" fill="none" fillRule="evenodd">
        <rect x=".5" y="3.177" width="24" height="19" rx="2" />
        <rect fill="#101010" x=".5" y="3.177" width="24" height="4" rx="2" />
        <path strokeWidth="2" d="M6.487.57v5M19 .57v5" />
      </g>
    </svg>
  )
}
